<template>
    <Wrapper>
        <div>
            <span class="anchor" id="alerts"></span>
            <section class="row bg-alt pt-1 pb-2 mb-2">
                <div class="col-md-12">
                    <h4 class="mb-4 text-muted font-weight-light">Alerts &amp; Notifications</h4>
                    <div class="row">
                        <div class="col-sm-6">
                            <!-- standard alerts -->
                            <div class="mt-1 alert alert-primary alert-dismissible fade show" role="alert">
                              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&#xD7;</span>
                              </button>
                              <span class="font-weight-bold">Heads up!</span> Vestibulum tincidunt eros eget luctus. 
                              Nulla <a href="#" class="alert-link">primary</a>.
                            </div>
                            
                            <div class="mt-1 alert alert-danger alert-dismissible fade show" role="alert">
                              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&#xD7;</span>
                              </button>
                              <span class="font-weight-bold">Heads up!</span> Vestibulum tincidunt eros eget luctus. 
                              Nulla <a href="#" class="alert-link">danger</a>.
                            </div>
                            
                            <div class="mt-1 alert alert-info alert-dismissible fade show" role="alert">
                              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&#xD7;</span>
                              </button>
                              <span class="font-weight-bold">Heads up!</span> Vestibulum tincidunt eros eget luctus. 
                              Nulla <a href="#" class="alert-link">info</a>.
                            </div>
                            <!-- /standard alerts -->
                            
                            <div class="mt-1">
                                <a href="" data-target="#smallModal" data-toggle="modal" class="btn btn-outline-danger">Click me for pop-up alert !</a>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <!-- inverse background alerts -->
                            <div class="mt-1 alert alert-primary bg-primary text-white alert-dismissible fade show" role="alert">
                              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&#xD7;</span>
                              </button>
                              <span class="font-weight-bold">Womp!</span> Vestibulum notify ullamcorper alert eget luctus.
                            </div>
                            
                            <div class="mt-1 alert alert-danger bg-danger text-white alert-dismissible fade show" role="alert">
                              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&#xD7;</span>
                              </button>
                              <span class="font-weight-bold">Danger!</span> Vestibulum notify ullamcorper alert eget luctus.
                            </div>
                            
                            <div class="mt-1 alert alert-success bg-success alert-dismissible fade show" role="alert">
                              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&#xD7;</span>
                              </button>
                              <span class="font-weight-bold">Success!</span> Vestibulum notify ullamcorper alert eget luctus.
                            </div>
                            <!-- /inverse background alerts -->
                        </div>
                    </div>
                </div>
            </section>
            
            <span class="anchor" id="badges"></span>
            <section class="py-2 my-2">
                    <div class="row">
                        <div class="col-md-12">
                            <h4 class="mb-4 text-muted font-weight-light">Badges</h4>
                            <div class="row mt-2">
                               <div class="col-lg-3 pb-2">
                                    <h6>Normal</h6>
                                    <a href="" class="mr-1"><span class="badge badge-dark">badge</span></a>
                                    <a href="" class="mr-1"><span class="badge badge-success">success</span></a>
                                    <a href="" class="mr-1"><span class="badge badge-danger">danger</span></a>
                                    <div class="w-100 my-3"></div>
                                    <a href="" class="mr-1"><span class="badge badge-warning">warning</span></a>
                                    <a href="" class="mr-1"><span class="badge badge-info">info</span></a>
                                    <a href="" class="mr-1"><span class="badge badge-primary">primary</span></a>
                                    <div class="w-100 my-3"></div>
                                    <a href="" class="mr-1"><span class="badge badge-pill badge-dark">pill</span></a>
                                    <a href="" class="mr-1"><span class="badge badge-pill badge-success">100k</span></a>
                                    <a href="" class="mr-1"><span class="badge badge-pill badge-info">2</span></a>
                                    <a href="" class="mr-1"><span class="badge badge-pill badge-danger">378</span></a>
                                    <a href="" class="mr-1"><span class="badge badge-pill badge-warning">tag</span></a>
                                    <a href="" class="mr-1"><span class="badge badge-pill badge-primary">1123</span></a>
                                </div>
                                <div class="col-lg-4 pb-2">
                                    <h5>Heading 5</h5>
                                    <h5 class="mt-2">
                                        <a href="" class="mr-1"><span class="badge badge-dark">badge</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-success">success</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-danger">danger</span></a>
                                        <div class="w-100 my-3"></div>
                                        <a href="" class="mr-1"><span class="badge badge-warning">warning</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-info">info</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-primary">primary</span></a>
                                        <div class="w-100 my-3"></div>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-dark">pill</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-success">100k</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-info">2</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-danger">378</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-warning">tag</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-primary">1123</span></a>
                                    </h5>
                                </div>
                                <div class="col-lg-5 pb-2">
                                    <h3>Heading 3</h3>
                                    <h3>
                                        <a href="" class="mr-1"><span class="badge badge-dark">badge</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-success">success</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-danger">danger</span></a>
                                        <div class="w-100 my-3"></div>
                                        <a href="" class="mr-1"><span class="badge badge-warning">warning</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-info">info</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-primary">primary</span></a>
                                        <div class="w-100 my-3"></div>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-dark">pill</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-success">100k</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-info">2</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-danger">378</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-warning">tag</span></a>
                                        <a href="" class="mr-1"><span class="badge badge-pill badge-primary">1123</span></a>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
            </section>
            
            <span class="anchor" id="breadcrumbs"></span>
            <section class="row bg-alt py-2 mt-2">
                <div class="col-12">
                    <h4 class="mb-4 text-muted font-weight-light">Breadcrumbs &amp; Pagination</h4>
                </div>
                <div class="col-md-6">
                    <nav class="breadcrumb">
                      <a class="breadcrumb-item" href="#">Home</a>
                      <a class="breadcrumb-item" href="#">Path</a>
                      <a class="breadcrumb-item" href="#">Path</a>
                      <span class="breadcrumb-item active">Active</span>
                    </nav>
                </div>
                <div class="col-md-6">
                    <nav aria-label="Page navigation">
                      <ul class="pagination justify-content-center">
                        <li class="page-item">
                          <a class="page-link" href="" aria-label="Previous">
                            <i class="fa fa-chevron-left ion-ios-arrow-left icon-arrow-left"></i>
                            <span class="sr-only">Previous</span>
                          </a>
                        </li>
                        <li class="page-item"><a class="page-link" href="">1</a></li>
                        <li class="page-item"><a class="page-link" href="">2</a></li>
                        <li class="page-item"><a class="page-link" href="">3</a></li>
                        <li class="page-item"><a class="page-link" href="">4</a></li>
                        <li class="page-item"><a class="page-link" href="">5</a></li>
                        <li class="page-item">
                          <a class="page-link" href="" aria-label="Next">
                            <i class="fa fa-chevron-right ion-ios-arrow-right icon-arrow-right"></i>
                            <span class="sr-only">Next</span>
                          </a>
                        </li>
                      </ul>
                    </nav>
                </div>
            </section>
            
            <span class="anchor" id="buttons"></span>
            <section class="row bg-alt align-items-center py-2 mb-2">
                <div class="col-12">
                    <h4 class="mb-4 text-muted font-weight-light">Buttons</h4>
                    <div class="row mt-2">
                        <div class="col-lg col-4"><button class="btn btn-outline-primary mr-1">Primary</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-outline-secondary mr-1">Secondary</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-outline-info mr-1">Info</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-outline-danger mr-1">Danger</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-outline-success mr-1">Success</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-outline-warning mr-1">Warning</button></div>
                        <div class="w-100 my-3"></div>
                        <div class="col-lg col-4"><button class="btn btn-primary mr-1">Primary</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-secondary mr-1">Secondary</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-info mr-1">Info</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-danger mr-1">Danger <span class="badge badge-light badge-pill">!</span></button> </div>
                        <div class="col-lg col-4"><button class="btn btn-success mr-1">Success</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-warning mr-1">Warning</button></div>
                        <div class="w-100 my-3"></div>
                        <div class="col-xl col-4"><button class="btn btn-lg btn-primary mr-1">Primary</button> </div>
                        <div class="col-xl col-4"><button class="btn btn-lg btn-secondary mr-1">Secondary</button> </div>
                        <div class="col-xl col-4"><button class="btn btn-lg btn-info mr-1">Info</button> </div>
                        <div class="col-xl col-4"><button class="btn btn-lg btn-danger mr-1">Danger</button> </div>
                        <div class="col-xl col-4"><button class="btn btn-lg btn-success mr-1">Success</button> </div>
                        <div class="col-xl col-4"><button class="btn btn-lg btn-warning mr-1">Warning</button></div>
                        <div class="w-100 my-3"></div>
                        <div class="col-lg col-4"><button class="btn btn-sm btn-primary mr-1">Primary</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-sm btn-secondary mr-1">Secondary</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-sm btn-info mr-1">Info</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-sm btn-danger mr-1">Danger</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-sm btn-success mr-1">Success</button> </div>
                        <div class="col-lg col-4"><button class="btn btn-sm btn-warning mr-1">Warning</button></div>
                        <div class="w-100 my-3"></div>
                        <div class="col-lg col-6 py-2">
                            <div class="btn-group">
                              <button type="button" class="btn btn-secondary">Left</button>
                              <button type="button" class="btn btn-secondary">Middle</button>
                              <button type="button" class="btn btn-secondary">Right</button>
                            </div>
                        </div>
                        <div class="col-lg col-6 py-2">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Dropdown
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" href="#">Action</a>
                                <a class="dropdown-item" href="#">Another action</a>
                                <a class="dropdown-item" href="#">Something else here</a>
                              </div>
                            </div>
                        </div>
                        <div class="col-lg col-6 py-2">
                            <div class="btn-group">
                              <button type="button" class="btn btn-secondary">Split</button>
                              <button type="button" class="btn btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="sr-only">Toggle Dropdown</span>
                              </button>
                              <div class="dropdown-menu">
                                <a class="dropdown-item" href="#">Action</a>
                                <a class="dropdown-item" href="#">Another action</a>
                                <a class="dropdown-item" href="#">Something else here</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="#">Separated link</a>
                              </div>
                            </div>
                        </div>
                        <div class="col-lg col-6 py-2">
                            <button type="button" class="btn btn-secondary btn-block">Block</button>
                        </div>
                        <div class="col-lg col-6 py-2">
                            <button type="button" class="btn btn-outline-light">Light</button>
                        </div>
                        <div class="col-lg col-6 py-2">
                            <button type="button" class="btn btn-outline-dark">Dark</button>
                        </div>
                    </div>
                </div>
            </section>
            
            <span class="anchor" id="colors"></span>
            <section class="row py-2 my-2">
                <div class="col-12">
                    <h4 class="mb-4 text-muted font-weight-light">Colors</h4>
                </div>
                <div class="col-md-6">
                    <p class="text-primary">.text-primary <a href class="text-primary">link</a></p>
                    <p class="text-secondary">.text-secondary <a href class="text-secondary">link</a></p>
                    <p class="text-success">.text-success <a href class="text-success">link</a></p>
                    <p class="text-danger">.text-danger <a href class="text-danger">link</a></p>
                    <p class="text-warning">.text-warning <a href class="text-warning">link</a></p>
                    <p class="text-info">.text-info <a href class="text-info">link</a></p>
                    <p class="text-light">.text-light <a href class="text-light">link</a></p>
                    <p class="text-dark">.text-dark <a href class="text-dark">link</a></p>
                </div>
                <div class="col-md-6">
                    <div class="p-2 mb-2 bg-primary text-white">.bg-primary</div>
                    <div class="p-2 mb-2 bg-secondary text-white">.bg-secondary</div>
                    <div class="p-2 mb-2 bg-success text-white">.bg-success</div>
                    <div class="p-2 mb-2 bg-danger text-white">.bg-danger</div>
                    <div class="p-2 mb-2 bg-warning text-white">.bg-warning</div>
                    <div class="p-2 mb-2 bg-info text-white">.bg-info</div>
                    <div class="p-2 mb-2 bg-light text-gray-dark">.bg-light</div>
                    <div class="p-2 mb-2 bg-dark text-white">.bg-dark</div>
                    <div class="p-2 mb-2 bg-white text-gray-dark">.bg-white</div>
                </div>
            </section>
            
            <span class="anchor" id="jumbotron"></span>
            <section class="row d-flex align-items-center justify-content-center bg-alt border border-left-0 border-right-0 py-5">
                <div class="mx-auto col-md-10 mb-4">
                    <div class="jumbotron mb-0 d-flex align-items-center flex-column justify-content-center p-5" id="header">
                        <h1 class="display-4">Jumbotron</h1>
                        <p>Some perfectly centered content goes here</p>
                        <p class="lead">
                            <a class="btn btn-secondary btn-lg" href="#" role="button">Learn more</a>
                        </p>
                    </div>
                </div>
            </section>
            
            <span class="anchor" id="lists"></span>
            <section class="py-2 my-2">
                <div class="row">
                        <div class="col-md-12">
                            
                            <h4 class="mb-4 text-muted font-weight-light">Lists & Accordions</h4>
                            
                            <div class="row my-3">
                                <div class="col-sm-6">
                                
                                    <!-- list card -->
                                    <div class="card border-0" id="card_list">
                                       
                                        <!-- list -->
                                        <div class="list-group">
                                            <a href="#" class="list-group-item list-group-item-action">
                                                <p class="list-group-item-text m-0">Grapes</p>
                                            </a>
                                            <a href="#" class="list-group-item list-group-item-action">
                                                <p class="list-group-item-text m-0">
                                                    Milk
                                                    <span class="float-right"><i class="ion-ios-star-outline">✔</i></span>
                                                </p>
                                            </a>
                                            <a href="#" class="list-group-item list-group-item-action">
                                                <p class="list-group-item-text m-0">Apple Chips</p>
                                            </a>
                                            <a href="#" class="list-group-item list-group-item-action">
                                                <p class="list-group-item-text m-0">Fried Dough</p>
                                            </a>
                                            <a href="#" class="list-group-item list-group-item-action">
                                                <p class="list-group-item-text m-0">Berries</p>
                                            </a>
                                            <a href="#" class="list-group-item list-group-item-action">
                                                <p class="list-group-item-text m-0">Salad</p>
                                            </a>
                                            <a href="#" class="list-group-item list-group-item-action">
                                                <p class="list-group-item-text m-0">Cookies &amp; Crackers</p>
                                            </a>
                                            <a href="#" class="list-group-item list-group-item-action">
                                                <p class="list-group-item-text m-0 font-weight-bold">See More...</p>
                                            </a>
                                        </div>
                                        <!-- /list -->
                                       
                                    </div>
                                    <!-- /list card -->
                                    
                                </div><!-- /col -->
                                <div class="col-sm-6">
                                    
                                    <!-- /accordion -->
                                    <div id="accordion" class="accordion mb-4">
                                        <div class="card card-default panel">
                                            <a href="" class="card-header text-primary bg-dark" data-toggle="collapse" data-parent="#accordion" data-target="#collapseOne">
                                                <span class="card-title">
                                                    Panel 1
                                                </span>
                                            </a>
                                            <div id="collapseOne" class="collapse show">
                                                <div class="card-body">
                                                <p>Food truck quinoa nesciunt laborum for labo lucn. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Leggings occaecat
                                                    craft beer farm-to-table, raw denim aesthetic codeply nesciunt you probably haven&apos;t heard of them accusamus labore sustainable VHS.
                                                </p>
                                                </div>
                                            </div>
                                            <a href="" class="card-header text-primary bg-dark collapsed" data-toggle="collapse" data-parent="#accordion" data-target="#collapseTwo">
                                                <span class="card-title">
                                                   Panel 2
                                                </span>
                                            </a>
                                            <div id="collapseTwo" class="collapse">
                                                <div class="card-body">
                                                <p>Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt
                                                    cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat
                                                    craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven&apos;t heard of them accusamus labore sustainable VHS.
                                                </p>
                                                </div>
                                            </div>
                                            <a href="" class="card-header text-primary bg-dark collapsed" data-toggle="collapse" data-parent="#accordion" data-target="#collapseThree">
                                                <span class="card-title">
                                                  Panel 3
                                                </span>
                                            </a>
                                            <div id="collapseThree" class="collapse">
                                                <div class="card-body">
                                                <p>Anim pariatur codeply reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt
                                                    aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. samus labore sustainable VHS.
                                                </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /accordion -->
                                    
                                    <!-- collapse -->
                                    <div class="card">
                                        <h4 class="card-header">
                                            <a href="#" class="float-right" data-target="#collapseMe" data-toggle="collapse">
                                                <i class="align-middle icon-options-vertical"></i>
                                            </a>
                                            Heading
                                        </h4>
                                        <div class="collapse show" id="collapseMe">
                                            <div class="card-body">
                                            <p class="">Shiny, shiny. Varius azdipiscing elit. Duis pharetra codeply varius quam sit amet vulputate. Ovi lipsim diro? Then puska craft beer labore wes anderson cred nesciunt sapiente ea proident!</p>
                                            <button class="btn btn-secondary">Take Action!</button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /collapse -->
                                    
                                </div><!-- /col -->
                            </div>     
                        </div>
                    </div>
            </section>
            
            <span class="anchor" id="modals"></span>
            <section class="row py-2 mt-2 bg-alt">
                <div class="col-md-12">
                    <h4 class="mb-4 text-muted font-weight-light">Modals</h4>
                    
                    <h6 class="text-center text-wide mt-5">Examples</h6>
                    <ul class="list-inline text-center mb-5">
                        <li class="list-inline-item py-1"><a href="" class="btn btn-outline-secondary btn-sm" data-target="#myModal" data-toggle="modal">Standard</a></li>
                        <li class="list-inline-item py-1"><a href="" class="btn btn-outline-secondary btn-sm" data-target="#smallModal" data-toggle="modal">Small</a></li>
                        <li class="list-inline-item py-1"><a href="" class="btn btn-outline-secondary btn-sm" data-target="#largeModal" data-toggle="modal">Large</a></li>
                    </ul>
                    
                    <!-- standard modal -->
                    <div class="modal fade mt-5" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                      <div class="modal-dialog" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h4 class="modal-title" id="myModalLabel">Modal title</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&#xD7;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <p>
                                Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.
                                Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.
                                Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                                Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.
                            </p>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary">Save changes</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- small modal -->
                    <div class="modal mt-5" tabindex="-1" role="dialog" aria-hidden="true" id="smallModal">
                      <div class="modal-dialog modal-sm">
                        <div class="modal-content text-center">
                            <div class="modal-body text-center">
                                <div class="alert text-white bg-primary fade show" role="alert">
                                    <span class="font-weight-bold">Womp!</span> There it is.
                                </div>
                                <a data-dismiss="modal">
                                  <span aria-hidden="true" class="display-2">&#xD7;</span>
                                </a>
                            </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- large modal -->
                    <div class="modal fade mt-5" tabindex="-1" role="dialog" aria-hidden="true" id="largeModal">
                      <div class="modal-dialog modal-lg">
                        <div class="modal-content text-center p-3">
                            <div class="modal-body text-center">
                                <h1>Large Modal</h1>
                                <p class="lead">
                                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt
                                    aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Ad vegan excepteur butcher vice lomo. Leggings occaecat
                                    craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven&apos;t heard of them accusamus labore sustainable VHS.
                                </p>
                                <button type="button" data-dismiss="modal" class="btn btn-lg btn-primary mt-2 text-uppercase">
                                  <span aria-hidden="true">Close</span>
                                </button>
                            </div> 
                        </div>
                      </div>
                    </div>
                    
                </div>
            </section>
            
            <a class="anchor" id="progress"></a>
            <section class="py-2 my-2">
                <div class="row">
                        <div class="col-md-12">
                            
                            <h4 class="mb-4 text-muted font-weight-light">Progress Bars</h4>
                            
                            <!-- progress bars -->
                            <div id="card_stats">
                                <div class="card-body p-0">
                                    <div class="row">
                                        <div class="col-lg-6 my-2">
                                            <div class="card card-body p-3"> <span class="text-primary"><span class="badge badge-primary float-right">+ 13%</span> Sign-ups </span>
                                                <div class="progress mt-4">
                                                    <div class="progress-bar w-25 bg-primary"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 my-2">
                                            <div class="card card-body p-3"> <span class="text-primary"><span class="badge badge-primary float-right">80%</span> Usage </span>
                                                <div class="progress mt-4">
                                                    <div class="progress-bar w-75"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 my-2">
                                            <div class="card card-body p-3"> <span class="text-primary"><span class="badge badge-primary float-right">78</span> Bursts </span>
                                                <div class="progress mt-4">
                                                    <div class="progress-bar bg-primary w-75"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 my-2">
                                            <div class="card card-body p-3"> <span class="text-success"><span class="badge badge-success float-right">+ 26%</span> Returning </span>
                                                <div class="progress mt-4">
                                                    <div class="progress-bar bg-success w-25"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 my-2">
                                            <div class="card card-body p-3"> <span class="text-primary"><span class="badge badge-primary float-right">201</span> Sales </span>
                                                <div class="progress mt-4">
                                                    <div class="progress-bar w-50 bg-primary"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 my-2">
                                            <div class="card card-body p-3"> <span class="text-success"><span class="badge badge-success float-right">+ 74%</span> Pageviews </span>
                                                <div class="progress mt-4">
                                                    <div class="progress-bar bg-success w-75"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /progress bars -->
                                    
                        </div>
                    </div>
            </section>
            
            <span class="anchor" id="tables"></span>
            <section class="row bg-alt py-2 my-2">
                <div class="col-md-12">
                    
                    <h4 class="mb-4 text-muted font-weight-light">Tables</h4>
                    <table class="table table-hover table-sm">
                        <thead>
                          <tr>
                            <th>Location</th>
                            <th>Points</th>
                            <th>Region</th>
                            <th class="text-right">Mean</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr><td>Newport, RI, USA</td>
                            <td>3</td>
                            <td>New England</td>
                            <td class="text-right">45001</td>
                          </tr>
                          <tr><td>Chicago, IL, USA</td>
                            <td>5</td>
                            <td>Mid West</td>
                            <td class="text-right">106455</td>
                          </tr>
                          <tr><td>New York, NY, USA</td>
                            <td>10</td>
                            <td>Mid Atlantic</td>
                            <td class="text-right">39097</td>
                          </tr>
                        </tbody>
                    </table>
                    
                    <div class="table-responsive">
                        <table class="table table-striped table-hover table-bordered">
                            <thead>
                            <tr>
                                <th class="id"><a>Id <i class="fa fa-sort"></i></a></th>
                                <th class="name"><a>Name <i class="fa fa-sort"></i></a></th>
                                <th class="description">Description</th>
                                <th class="field3"><a>Link <i class="fa fa-sort"></i></a></th>
                                <th class="field4"><a>Reason <i class="fa fa-sort"></i></a></th>
                                <th class="field5"><a>Area <i class="fa fa-sort"></i></a></th>
                                <th class="text-center"><i class="ion-ios-trash-outline"></i></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td>alpha1</td>
                              <td>name 1</td>
                              <td>Description of item #1</td>
                              <td><a href="#" class="link">alpha</a></td>
                              <td>Some stuff about rec: 1</td>
                              <td>23</td>
                              <td class="text-center"><a href="">x</a></td>
                            </tr><tr>
                              <td>bob10</td>
                              <td>name 10</td>
                              <td>Description of item #10</td>
                              <td><a href="#" class="link">bob</a></td>
                              <td>Some stuff about rec: 10</td>
                              <td>22</td>
                              <td class="text-center"><a href="">x</a></td>
                            </tr><tr>
                              <td>daniel11</td>
                              <td>name 11</td>
                              <td>Description of item #11</td>
                              <td><a href="#" class="link">daniel</a></td>
                              <td>Some stuff about rec: 11</td>
                              <td>44</td>
                              <td class="text-center"><a href="">x</a></td>
                            </tr><tr>
                              <td>grace12</td>
                              <td>name 12</td>
                              <td>Description of item #12</td>
                              <td><a href="#" class="link">grace</a></td>
                              <td>Some stuff about rec: 12</td>
                              <td>19</td>
                              <td class="text-center"><a href="">x</a></td>
                            </tr><tr>
                              <td>alpha13</td>
                              <td>name 13</td>
                              <td>Description of item #13</td>
                              <td><a href="#" class="link">alpha</a></td>
                              <td>Some stuff about rec: 13</td>
                              <td>13</td>
                              <td class="text-center"><a href="">x</a></td>
                            </tr><tr>
                              <td>alpha14</td>
                              <td>name 14</td>
                              <td>Description of item #14</td>
                              <td><a href="#" class="link">alpha</a></td>
                              <td>Some stuff about rec: 14</td>
                              <td>14</td>
                              <td class="text-center"><a href="">x</a></td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="7">
                                    <div class="text-center">
                                        <nav aria-label="Page navigation">
                                          <ul class="pagination justify-content-center">
                                            <li class="page-item">
                                              <a class="page-link" href="" aria-label="Previous">
                                                <i class="fa fa-chevron-left ion-ios-arrow-left icon-arrow-left"></i>
                                                <span class="sr-only">Previous</span>
                                              </a>
                                            </li>
                                            <li class="page-item"><a class="page-link" href="">1</a></li>
                                            <li class="page-item"><a class="page-link" href="">2</a></li>
                                            <li class="page-item"><a class="page-link" href="">3</a></li>
                                            <li class="page-item"><a class="page-link" href="">4</a></li>
                                            <li class="page-item"><a class="page-link" href="">5</a></li>
                                            <li class="page-item">
                                              <a class="page-link" href="" aria-label="Next">
                                                <i class="fa fa-chevron-right ion-ios-arrow-right icon-arrow-right"></i>
                                                <span class="sr-only">Next</span>
                                              </a>
                                            </li>
                                          </ul>
                                        </nav>
                                    </div>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="table table-bordered table-hover">
                                <thead class="thead-inverse">
                                  <tr>
                                    <th>Location</th>
                                    <th>Points</th>
                                    <th class="text-right">Mean</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr><td>Long Island, NY, USA</td>
                                    <td>7</td>
                                    <td class="text-right">45,001</td>
                                  </tr>
                                  <tr><td>Chicago, Illinois, USA</td>
                                    <td>8</td>
                                    <td class="text-right">106,455</td>
                                  </tr>
                                  <tr><td>New York, New York, USA</td>
                                    <td>4</td>
                                    <td class="text-right">39,097</td>
                                  </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="table table-bordered table-hover">
                                <thead class="thead-inverse">
                                  <tr>
                                    <th>Location</th>
                                    <th>Points</th>
                                    <th class="text-right">Result</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>Long Island, NY, USA</td>
                                    <td>1</td>
                                    <td class="text-right">5,001</td>
                                  </tr>
                                  <tr>
                                    <td>Chicago, Illinois, USA</td>
                                    <td>2</td>
                                    <td class="text-right">6,455</td>
                                  </tr>
                                  <tr>
                                    <td>New York, New York, USA</td>
                                    <td>3</td>
                                    <td class="text-right">9,097</td>
                                  </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
            
            <a class="anchor" id="tabs"></a>
            <section class="py-2 my-2">
                <div class="row">
                    <div class="col-md-12">
                                    
                        <h4 class="mb-4 text-muted font-weight-light">Tabs</h4>
                        
                        <!--tabs-->
                        <ul id="tabsJustified" class="nav nav-tabs">
                            <li class="nav-item">
                                <a href="" data-target="#home1" data-toggle="tab" class="nav-link small text-uppercase">Home</a>
                            </li>
                            <li class="nav-item">
                                <a href="" data-target="#profile1" data-toggle="tab" class="nav-link small text-uppercase active">Profile</a>
                            </li>
                            <li class="nav-item">
                                <a href="" data-target="#messages1" data-toggle="tab" class="nav-link small text-uppercase">Messages</a>
                            </li>
                        </ul>
                        <!--/tabs-->
                        <br>
                        <div id="tabsJustifiedContent" class="tab-content">
                            <div class="tab-pane fade" id="home1">
                                <div class="list-group"> 
                                    <a href="" class="list-group-item d-inline-block"><span class="float-right badge badge-pill badge-dark">51</span> Home Link</a>
                                    <a href="" class="list-group-item d-inline-block"><span class="float-right badge badge-pill badge-dark">8</span> Link 2</a>
                                    <a href="" class="list-group-item d-inline-block"><span class="float-right badge badge-pill badge-dark">23</span> Link 3</a>
                                    <a href="" class="list-group-item d-inline-block text-muted">Link n..</a>
                                </div>
                            </div>
                            <div class="tab-pane fade active show" id="profile1">
                                <div class="row pb-2">
                                    <div class="col-12">
                                        <p>Tabs can be used to contain a variety of content &amp; elements. They are a good way to group <a href="" class="link">relevant content</a>.
                                        Display initial content in context to the user. Enable the user to flow through <a href="" class="link">more</a> information as needed.  
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="messages1">
                                <div class="list-group"> 
                                    <a href="" class="list-group-item d-inline-block"><span class="float-right badge badge-pill badge-dark">44</span> Message 1</a>
                                    <a href="" class="list-group-item d-inline-block"><span class="float-right badge badge-pill badge-dark">8</span> Message 2</a>
                                    <a href="" class="list-group-item d-inline-block"><span class="float-right badge badge-pill badge-dark">23</span> Message 3</a>
                                    <a href="" class="list-group-item d-inline-block text-muted">Message n..</a>
                                </div>
                            </div>
                        </div>
                        <!--/tabs content-->
                    </div>
                </div>
                <!-- /row -->
            </section>
            
            <span class="anchor" id="typo"></span>
            <section class="row bg-alt py-2 my-2">
                <div class="col-12">
                    <h4 class="mb-4 text-muted font-weight-light">Typography</h4>
                </div>
                <div class="col-lg-4">
                    <h1>Heading 1</h1>
                    <h2>Heading 2</h2>
                    <h3>Heading 3</h3>
                    <h4>Heading 4</h4>
                    <h5>Heading 5</h5>
                    <h6>Heading 6</h6>
                    <hr>
                    <h5>Heading 5<sup class="badge badge-pill badge-dark">sup</sup></h5>
                    <h5>Heading 5<sub>sub</sub></h5>
                </div>
                <div class="col-lg">
                    <p class="lead">Lead text</p>
                    <p class="font-weight-bold">text bold</p>
                    <p class="small">small fine print</p>
                    <p class="text-muted">muted text</p>
                    <p><mark>highlight</mark> text</p>
                    <p class="text-uppercase">uppercase text</p>
                    <p><u>underlined text</u></p>
                    <p><em>italicized text</em></p>
                </div>
                <div class="col-lg-6">
                    <p class="display-4">Display 4</p>
                    <p class="display-3">Display 3</p>
                    <p class="display-2">Display 2</p>
                    <p class="display-1">Display 1</p>
                </div>
            </section>
            
            <span class="anchor" id="videos"></span>
            <section class="py-2 my-2">
                <div class="row">
                    <div class="col-12">
                        <h4 class="mb-4 text-muted font-weight-light">Videos</h4>
                    </div>
                    <div class="col-lg-6 col-md-8 mx-auto">
                        <div class="embed-responsive embed-responsive-16by9">
                          <iframe class="embed-responsive-item" :src="$config.app.assetPath + 'videos/urban.mp4'" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
                <!-- /row -->
            </section>
        </div>
    </Wrapper>
</template>
<script>
import { Wrapper } from '../components';

export default {
    components: {
        Wrapper
    }
}
</script>
